import styled from 'styled-components';

import View from '/imports/pdf/core/ui/atoms/View';

const BlockItem = styled(View)`
  margin-bottom: ${({ noMargin, theme }) => (noMargin ? 0 : theme.convertPt(20))};
`;

export default BlockItem;
